import { startCase } from 'lodash';
import { default as React, useEffect } from 'react';
import { medicationsSummaryAsync } from '../Async/MedicationsSummaryAsync';
import { ArrowLeftIcon, ErrorCircleIcon, PrintIcon, StopHandIcon, TickIcon } from '../Components/Icons';
import { LayoutCentral } from '../Components/LayoutCentral';
import { LoadingPlaceholder } from '../Components/Placeholder';
import { PatientMedicationHistoryStatus } from '../Contracts/MedicationModels';
import { useAsync } from '../Hooks/useAsync';
import { MedicationTitle } from './MedicationTitle';
import { useHttpConfig } from '../Shared/HttpRequestExecutor';
import { primaryBlue } from '../Styles/Colours';
import { HistorySummaryStatusColour, HistorySummaryTable } from '../HistorySummaryTable/HistorySummaryTable';
import styles from './PatientMedicationHistoryDisplay.module.css';
export var PatientMedicationHistoryDisplay = function (props) {
    var httpConfig = useHttpConfig();
    var patientMedicationAsync = useAsync({
        httpConfig: httpConfig,
        defaultValue: { history: [] },
        getApi: medicationsSummaryAsync
    });
    useEffect(function () {
        patientMedicationAsync.getApi(props.patientMedication.id);
    }, [props.patientMedication]);
    var patientMedicationHistory = patientMedicationAsync.data;
    function patientMedicationHistoryColour(status) {
        switch (status) {
            case PatientMedicationHistoryStatus.Draft:
            case PatientMedicationHistoryStatus.Updated:
                return HistorySummaryStatusColour.Yellow;
            case PatientMedicationHistoryStatus.Stopped:
                return HistorySummaryStatusColour.Grey;
            case PatientMedicationHistoryStatus.EnteredInError:
            case PatientMedicationHistoryStatus.Expired:
            case PatientMedicationHistoryStatus.Declined:
            case PatientMedicationHistoryStatus.ElectronicFailure:
                return HistorySummaryStatusColour.Red;
            case PatientMedicationHistoryStatus.Finalised:
            case PatientMedicationHistoryStatus.Submitted:
            case PatientMedicationHistoryStatus.Accepted:
                return HistorySummaryStatusColour.Green;
            case PatientMedicationHistoryStatus.Printed:
            case PatientMedicationHistoryStatus.Redelivered:
                return HistorySummaryStatusColour.Blue;
            default:
                return HistorySummaryStatusColour.Yellow;
        }
    }
    function patientMedicationHistoryIcon(status) {
        switch (status) {
            case PatientMedicationHistoryStatus.Draft:
            case PatientMedicationHistoryStatus.Updated:
                return null;
            case PatientMedicationHistoryStatus.Stopped:
                return StopHandIcon;
            case PatientMedicationHistoryStatus.EnteredInError:
            case PatientMedicationHistoryStatus.Expired:
            case PatientMedicationHistoryStatus.Declined:
            case PatientMedicationHistoryStatus.ElectronicFailure:
                return ErrorCircleIcon;
            case PatientMedicationHistoryStatus.Finalised:
            case PatientMedicationHistoryStatus.Submitted:
            case PatientMedicationHistoryStatus.Accepted:
                return TickIcon;
            case PatientMedicationHistoryStatus.Printed:
            case PatientMedicationHistoryStatus.Redelivered:
                return PrintIcon;
            default:
                return null;
        }
    }
    function patientMedicationHistoryStatusText(status) {
        switch (status) {
            case PatientMedicationHistoryStatus.EnteredInError:
                return 'Entered In Error';
            case PatientMedicationHistoryStatus.ElectronicFailure:
                return 'Failed To Stop';
            default:
                return startCase(status !== null && status !== void 0 ? status : '');
        }
    }
    var contents;
    if (patientMedicationAsync.loadCount === 0 || patientMedicationAsync.data === null) {
        contents = (React.createElement(LayoutCentral, null,
            React.createElement(LoadingPlaceholder, null)));
    }
    else {
        contents = (React.createElement(HistorySummaryTable, { historyItems: (patientMedicationHistory === null || patientMedicationHistory === void 0 ? void 0 : patientMedicationHistory.history)
                ? patientMedicationHistory.history.map(function (it) { return ({
                    statusColour: patientMedicationHistoryColour(it.status),
                    statusText: patientMedicationHistoryStatusText(it.status),
                    statusIcon: patientMedicationHistoryIcon(it.status),
                    source: it.source,
                    changedOn: it.changedOn,
                    changedBy: it.changedBy,
                    newValue: it.newValue,
                    oldValue: it.oldValue,
                    updatedStatus: it.status === PatientMedicationHistoryStatus.Updated
                }); })
                : [] }));
    }
    return (React.createElement("div", { className: styles.container },
        React.createElement("div", { className: styles.return },
            React.createElement(ArrowLeftIcon, { color: primaryBlue, noPadding: true, onClick: props.onClick }),
            React.createElement("span", { className: styles.returnText, onClick: props.onClick }, "Back to medication")),
        React.createElement("div", { className: styles.medicationTitle },
            React.createElement(MedicationTitle, { patientMedication: props.patientMedication, readOnly: true, onMedicationChosen: props.onMedicationChosen, controlledMedicationHandler: props.controlledMedicationHandler })),
        React.createElement("div", null, contents)));
};
